import { render, staticRenderFns } from "./BaseTransitionWrapper.vue?vue&type=template&id=2d8031cb&scoped=true&"
import script from "./BaseTransitionWrapper.vue?vue&type=script&lang=js&"
export * from "./BaseTransitionWrapper.vue?vue&type=script&lang=js&"
import style0 from "./BaseTransitionWrapper.vue?vue&type=style&index=0&id=2d8031cb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d8031cb",
  null
  
)

export default component.exports